module.exports = __webpack_public_path__ + "img/hoehle1.4ec3834b.jpg";